/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import validationInformationsDeclarationConvention from '../validationInformationsDeclarationConvention';


const validationStep8 = (
  PACS: any,
  selectedDeclarationType?: string | null,
) => {
  return {
    ...validationInformationsDeclarationConvention(PACS, selectedDeclarationType),
  }
};

export default validationStep8;
